import { CAMPAIGN_AUDIENCE_TYPES } from 'shared/constants/campaign.js';

// The audience payload the API stores, built from what the form has on screen. Every campaign form
// and the audience preview go through here, so a new audience type is mapped in one place instead
// of four.
export const buildCampaignAudience = ({
  audienceType,
  selectedLabels = [],
  inboxId = null,
  contactIds = [],
}) => {
  switch (audienceType) {
    case CAMPAIGN_AUDIENCE_TYPES.ALL_CONTACTS:
      return [{ type: 'AllContacts' }];
    case CAMPAIGN_AUDIENCE_TYPES.INBOX:
      return inboxId ? [{ type: 'Inbox', id: inboxId }] : [];
    case CAMPAIGN_AUDIENCE_TYPES.UPLOAD:
      return contactIds.length ? [{ type: 'ContactIds', ids: contactIds }] : [];
    case CAMPAIGN_AUDIENCE_TYPES.CONVERSATION_LABEL:
      return selectedLabels.map(id => ({ id, type: 'ConversationLabel' }));
    default:
      return selectedLabels.map(id => ({ id, type: 'Label' }));
  }
};
